import { Colors } from '../../common/constants/Colors';
import { t } from '../../common/i18n';
import { diffDays, formatDate, relativeDuration } from '../../common/utils/Date/Date';
import { Deadline, DeadlineStatusKind } from '../types';

const namespace = 'Deadlines';

/** Termíny do tolika dní spadají do skupiny „blíží se / tento měsíc". */
export const SOON_THRESHOLD_DAYS = 30;

export const getStatusKind = (deadline: Deadline): DeadlineStatusKind => {
  if (deadline.completedAt) {
    return 'completed';
  }

  const days = diffDays(deadline.dueDate);
  if (days < 0) {
    return 'overdue';
  }
  if (days <= SOON_THRESHOLD_DAYS) {
    return 'soon';
  }

  return 'upcoming';
};

/** Barva (color prop komponenty Text) odpovídající stavu. */
export const statusColor = (kind: DeadlineStatusKind): Colors => {
  switch (kind) {
    case 'overdue':
      return 'SystemRed';
    case 'soon':
      return 'SystemOrange';
    case 'completed':
      return 'SystemGreen';
    default:
      return 'Neutral600';
  }
};

/** Lidsky čitelný relativní popis termínu („za 18 dní", „po termínu o 3 dny", „splněno …"). */
export const relativeLabel = (deadline: Deadline): string => {
  if (deadline.completedAt) {
    return t('relative.completedAt', namespace, { date: formatDate(deadline.completedAt) });
  }

  const days = diffDays(deadline.dueDate);
  if (days === 0) {
    return t('relative.today', namespace);
  }

  const { unit, count } = relativeDuration(days);
  const direction = days < 0 ? 'overdue' : 'in';
  const key = `relative.${direction}${unit}`;

  // i18next vybere plurálovou variantu (_one/_few/_other) podle count
  return t(key, namespace, { count });
};
